import { styled } from '../../../../../core/theme/styled';

export const StyledProviderBannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin: 0 ${(props) => props.theme.sizes.normal};
`;

export const StyledImageContainer = styled.div`
  margin-bottom: ${(props) => props.theme.sizes.medium};
`;
